/** WeChat top-up /metering/finance/wechat-recharge (weChat.vue) */
export default {
  wechatRechargePage: {
    phDateStart: 'Start',
    phDateEnd: 'End',
    phTenant: 'Tenant name / ID',
    btnSearch: 'Search',
    btnReset: 'Reset',
    btnExport: 'Export',
    sectionTitle: 'WeChat top-up',
    sortDefault: 'Default sort',
    colSeqNo: 'Reference no.',
    colOccurTime: 'Time',
    colTenantName: 'Tenant',
    colRechargeAccount: 'Account',
    colAmount: 'Amount',
    colFeeRate: 'Fee rate',
    colFee: 'Fee',
    colStatus: 'Status',
    colAction: 'Actions',
    btnRefund: 'Refund',
    statusSuccess: 'Success',
    statusFail: 'Failed',
    statusRevoked: 'Revoked',
    shortcutYesterday: 'Yesterday',
    shortcutThisWeek: 'This week',
    shortcutLastWeek: 'Last week',
    shortcutThisMonth: 'This month',
    shortcutLastMonth: 'Last month',
    shortcutLast3Months: 'Last 3 months',
    shortcutLastYear: 'Last year',
    msgTenantListFail: 'Failed to load tenants',
    msgFetchFail: 'Failed to load data',
    msgFetchRecordFail: 'Failed to load top-up records',
    msgNoDataExport: 'No data to export',
    msgExportOk: 'Exported {count} row(s).',
    msgExportFail: 'Export failed',
    exportSheetName: 'WeChat top-up',
    filePrefix: 'WeChatTopUp',
    exportCurrentPage: 'Export current page',
    exportSelected: 'Export selected',
    exportAll: 'Export all',
    warnNoSelectedExport: 'Select rows to export first',
    msgExportOkSelected: 'Exported {count} selected row(s).',
    successExported: 'Exported {count} row(s).',
    successExportedLimit: 'Over {total} rows matched; exported first {count}.',
    exporting: 'Exporting…',
    msgRefundDev: 'Refund is not available yet.'
  }
}
